import React, { Component } from "react";
import Layout from "../../hoc/layout/layout";
import "./home.scss";
import $ from "jquery";
import Parallax from "parallax-js";
import cityline from "../../assets/images/cityline.png";
import cityline2 from "../../assets/images/cityline-2.png";
import cityline3 from "../../assets/images/cityline-3.png";
import cityline4 from "../../assets/images/cityline-4.png";
import titleText from "../../assets/images/normal-rollover-images/0.1-title-in-the-sky.png";

import ImageOne from "../../assets/images/without-border/image-one.png";
import ImageTwo from "../../assets/images/without-border/image-two.png";
import ImageThree from "../../assets/images/without-border/image-three.png";
import ImageFour from "../../assets/images/without-border/image-four.png";
import lobbyHover from "../../assets/images/normal-rollover-images/lobby-hover.png";
import lobbyText from "../../assets/images/normal-rollover-images/lobby-text.png";
import lobbyTextHover from "../../assets/images/normal-rollover-images/lobby-text-hover.png";
import autitoriumHover from "../../assets/images/normal-rollover-images/autitorium-hover.png";
import autitoriumText from "../../assets/images/normal-rollover-images/auditorium-text.png";
import autitoriumTextHover from "../../assets/images/normal-rollover-images/auditorium-text-hover.png";
import agendaHover from "../../assets/images/normal-rollover-images/agenda-hover.png";
import agendaText from "../../assets/images/normal-rollover-images/agenda-text.png";
import agendaTextHover from "../../assets/images/normal-rollover-images/agenda-text-hover.png";
import boatHover from "../../assets/images/normal-rollover-images/boat-hover.png";
import highlightsText from "../../assets/images/normal-rollover-images/highlights.png";
import highlightsTextHover from "../../assets/images/normal-rollover-images/highlights-hover.png";
import { Link } from "react-router-dom";
import { AuditoriumPopup } from "../../components/auditoriumPopup/auditoriumPopup";
import { LobbyHallPopup } from "../../components/lobbyHallPopup/lobbyHallPopup";
import AKAwebm from "../../assets/images/aka-clouds-new.webm";
import AKAogv from "../../assets/images/aka-clouds-new.ogv";
import AKAmp4 from "../../assets/images/aka-clouds-new.mp4";
import axios from "axios";
// import VideoPlayer from "../../components/videoPlayer/videoPlayer";
import VideoPlayer from "react-video-js-player";

// import AKABannermp4 from "../../assets/images/aka-banner-big.mp4";
// import AKABannerwebm from "../../assets/images/aka-banner.webm";
// import AKABannerogv from "../../assets/images/aka-banner.ogv";

import AKABannermp4 from "../../assets/images/hd-pink-III.mp4";
import AKABannerwebm from "../../assets/images/hd-pink-III.webm";
import AKABannerogv from "../../assets/images/hd-pink-III.ogv";

import videoPoster from "../../assets/images/video-Poster.jpg";
import { DefaultPlayer as Video } from "react-html5video";
import "react-html5video/dist/styles.css";

const hasWindow = typeof window !== "undefined" ? true : false;
if (hasWindow) {
  window.loader = true;
}

class Home extends Component {
  state = {
    auditoriumToggle: false,
    userTokenMain: "",
    lobbyHallToggle: false,
    timer: 5,
    openLobby: false,
    startAnimation: false,
    loader: true,
    video: {
      src: AKABannermp4,
      poster: videoPoster,
    },
    videoJsOptions: {
      autoplay: true,
      controls: false,
      sources: [
        {
          src: AKABannermp4,
          type: "video/mp4",
        },
      ],
    },
  };
  componentDidMount() {
    console.log("working");
    let getHopinUrl = localStorage.getItem("hopinUrl");
    let email_address = localStorage.getItem("email_address");
    let userToken = localStorage.getItem("userToken");

    this.setState({
      userTokenMain: userToken,
      hopinUrl: getHopinUrl,
      email_address: email_address,
    });
    if (email_address) {
      axios
        .get(
          `https://api.vfairs.com/v12/users?access_key=4hyr4hFaaFOGDgN9wyaKF22FKRsKzku6fkaN9&username=${email_address}`
        )
        .then((res) => {
          console.log(res.data[0].autologin_url);
          if (res.data) {
            this.setState({ vfairUrl: res.data[0].autologin_url });
          }
        });
    }
    if (hasWindow) {
      $(document).ready(function () {
        var scene = document.getElementById("scene");
        if (scene) {
          var parallaxInstance = new Parallax(scene);
          parallaxInstance.friction(0, 1);
        }
        if ($("#cloudVideo")[0]) {
          $("#cloudVideo")[0].play();
        }
      });

      var interval = setInterval(() => {
        if (document.readyState === "complete") {
          clearInterval(interval);
          setTimeout(() => {
            this.setState({
              loader: false,
            });
          }, 1000);
          setTimeout(() => {
            this.setState({
              startAnimation: true,
            });
          }, 200);
        }
      }, 100);
    }
  }

  countdown = null;
  countdownSetus = (popupName, stop = null) => {
    console.log(popupName);
    this.countdown = setInterval(() => {
      let timess = this.state.timer - 1;
      this.setState({
        timer: timess,
      });

      if (timess < 0) {
        if (popupName == "auditoriumToggle") {
          window.open(this.state.hopinUrl, "_blank");
        }
        if (popupName == "lobbyHallToggle") {
          this.takeHandler();
        }

        clearInterval(this.countdown);

        this.setState({
          timer: 5,
          [popupName]: false,
        });
      }
    }, 1000);
  };

  takeHandler = () => {
    window.open(this.state.vfairUrl, "_blank");
  };

  popupOpen = (popupName) => {
    var statuss = true;
    this.setState({
      [popupName]: true,
      openStatus: true,
    });
    // setTimeout(() => {
    //   this.setState({
    //     [popupName]: false,
    //   });
    // }, 5000);
    this.countdownSetus(popupName);
  };
  popupClose = (popupName) => {
    this.setState({
      openStatus: false,
      [popupName]: false,
      timer: 5,
      // timer: 0,
    });
    // this.countdownSetus(popupName, true);
    clearInterval(this.countdown);
    // setTimeout(() => {
    //   this.setState({
    //     timer: 5,
    //   });
    // }, 500);
  };

  // popupOpen = (popupName) => {
  //   this.setState({
  //     [popupName]: true,
  //   });
  //   setTimeout(() => {
  //     this.setState({
  //       [popupName]: false,
  //     });
  //   }, 5000);

  //   var countdown = setInterval(() => {
  //     let timess = this.state.timer - 1;
  //     this.setState({
  //       timer: timess,
  //     });
  //     if (timess < 0 || this.state[popupName] == false) {
  //       clearInterval(countdown);
  //       this.setState({
  //         timer: 5,
  //       });
  //     }
  //     // if (this.state[popupName] == false) {
  //     //   clearInterval(countdown);
  //     //   this.setState({
  //     //     timer: 5,
  //     //   });
  //     // }
  //   }, 1000);
  // };
  // popupClose = (popupName) => {
  //   this.setState({
  //     [popupName]: false,
  //     timer: 0,
  //   });
  // };

  render() {
    return (
      <>
        {/* <div className="loader-box"></div> */}

        <div
          id="overlay"
          className={this.state.loader ? "loader" : "loader active"}
        >
          <div className="inner-box">
            {/* <div className="loader-circle"></div>
            <div className="loader-line-mask">
              <div className="loader-line"></div>
            </div> */}
          </div>
        </div>

        <AuditoriumPopup
          hopinUrl={this.state.hopinUrl}
          vfairUrl={this.state.vfairUrl}
          timer={this.state.timer}
          auditoriumToggle={this.state.auditoriumToggle}
          auditoriumClose={() => this.popupClose("auditoriumToggle")}
        />
        <LobbyHallPopup
          hopinUrl={this.state.hopinUrl}
          vfairUrl={this.state.vfairUrl}
          timer={this.state.timer}
          lobbyHallToggle={this.state.lobbyHallToggle}
          lobbyHallClose={() => this.popupClose("lobbyHallToggle")}
        />
        <div
          className={
            this.state.startAnimation
              ? "home-banner-section active"
              : "home-banner-section"
          }
        >
          <div
            data-aos="fade-in"
            data-aos-delay="1500"
            className="image-box"
            data-relative-input="true"
            id="scene"
          >
            {/* <VideoPlayer
              controls={true}
              src={this.state.video.src}
              poster={this.state.video.poster}
              autoplay={true}
            /> */}

            <video
              id="cloudVideo"
              playsInline
              muted
              loop
              // src={this.state.akaVideo}
              poster={videoPoster}
            >
              <source src={AKABannerwebm} type="video/webm" />
              <source src={AKABannerogv} type="video/ogv" />
              <source src={AKABannermp4} type="video/mp4" />
            </video>

            {/* <Video
              autoPlay
              loop
              muted
              // controls={['PlayPause', 'Seek', 'Time', 'Volume', 'Fullscreen']}
              // poster="http://sourceposter.jpg"
              onCanPlayThrough={() => {
                // Do stuff
              }}
            >
              <source src={AKAwebm} type="video/webm" />
              <source src={AKAogv} type="video/ogv" />
              <source src={AKAmp4} type="video/mp4" />
              <track
                label="English"
                kind="subtitles"
                srcLang="en"
                src="http://source.vtt"
                default
              />
            </Video> */}

            <figure className="text-img">
              <img src={titleText} />
            </figure>

            <img className="city-image" src={cityline} />
            <div className="layer-box layer-2" data-depth="0.04">
              <img className="city-image-2" src={cityline2} />
              <div className="lobby-box">
                <a
                  href="https://events.aka1908.net/bouleleadership2021/vendors"
                  target="_blank"
                >
                  {/* <button
                  type="button"
                  onClick={() => this.popupOpen("lobbyHallToggle")}
                > */}
                  <figure>
                    <img
                      data-aos="fade-in"
                      data-aos-delay="1500"
                      className="img-normal main-image"
                      src={ImageOne}
                    />
                    <div className="image-outline">
                      <svg
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        // xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 238.3 135.8"
                        // style="enable-background: new 0 0 238.3 135.8"
                        // xml:space="preserve"
                      >
                        <path
                          className="st0"
                          d="M2,133.9l1.5-20c0,0,3.7-8-0.8-17.7L2,13.4l2.9-1.2l22.7-1c0,0,6-2.5,16,0l1.3,1.2l14,0.5l5.3,0.7l5.3,0.3H73
	c0,0,1.8-4.4,4.5-3.8l27.8,0.8c0,0,4.2-0.5,4,4.2l22.2,1.3c0,0,0.7-7.5,3.2-6.3l5.8-0.1l1.2-0.7h11.7l23,1.3c0,0,2.7-5.5,6.2-4.3
	c0,0,3.8-3.2,6.3,1.2c0,0,13-6.5,16.5-5.3c0,0,14.5-0.3,20.5,1.2l2.7,1.5c0,0,9.5-0.3,5.7,6.5l-2.3,1.7l-0.2,7.2l-3.5,2h5
	c0,0,4,0.5,3,7.3l0.2,64.5"
                        />
                      </svg>
                    </div>
                    <img className="img-hover" src={lobbyHover} />
                  </figure>
                  <div className="text-box">
                    <img
                      data-aos="fade-in"
                      data-aos-delay="1000"
                      className="img-normal"
                      src={lobbyText}
                    />
                    <img className="img-hover" src={lobbyTextHover} />
                  </div>
                  {/* </button> */}
                </a>
              </div>
              <div className="autitorium-box">
                <a
                  href={`https://events.aka1908.net/21991000/${this.state.userTokenMain}?redirect=recordings`}
                  target="_blank"
                >
                  {/* <button
                  type="button"
                  onClick={() => this.popupOpen("auditoriumToggle")}
                > */}
                  <figure>
                    <img
                      data-aos="fade-in"
                      data-aos-delay="1500"
                      className="img-normal main-image"
                      src={ImageThree}
                    />
                    <div className="image-outline">
                      <svg
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        // xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 178 295.5"
                        // style="enable-background: new 0 0 178 295.5"
                        // xml:space="preserve"
                      >
                        <path
                          className="st0"
                          d="M3,285.3V161.8c0,0-0.3-6,10.3-2.3c0,0,1.8-9.8,12.9-2.8v-118c0,0-0.5-5.2,6.4-3.5c0,0,1.9-4.9,4.1-5.9
	c0,0,3.6-6.7,6.4-7.2v-8c0,0,4.3-4.8,8.1-3.6l8.6-0.8l2.4-3.2l4.6-1.9h18.7l0.4,0.6l10.4-0.6l22.4-1l8.4-0.4h6.2
	c0,0,12.5-1.4,12.6,7.4v5.2c0,0,4.3,1.6,5.5,7.3c0,0,5,1.9,5.4,7.4c0,0,7.3,1.5,6.9,7.3l0,7.1l-0.3,7.6h-0.9l-1.6,204h9.5
	c0,0,5.1,0.8,4.6,7.2l0,28.9"
                        />
                      </svg>
                    </div>
                    <img className="img-hover" src={autitoriumHover} />
                  </figure>
                  <div className="text-box">
                    <img
                      data-aos="fade-in"
                      data-aos-delay="1000"
                      className="img-normal"
                      src={autitoriumText}
                    />
                    <img className="img-hover" src={autitoriumTextHover} />
                  </div>
                </a>
                {/* </button> */}
              </div>
            </div>

            <div className="layer-box layer-3" data-depth="0.07">
              <img className="city-image-3" src={cityline3} />
              <div className="agenda-box" data-depth="0.04">
                <Link to="/agenda">
                  <>
                    <figure>
                      <img
                        data-aos="fade-in"
                        data-aos-delay="1500"
                        className="img-normal main-image"
                        src={ImageTwo}
                      />
                      <div className="image-outline">
                        <svg
                          version="1.1"
                          id="Layer_1"
                          xmlns="http://www.w3.org/2000/svg"
                          // xmlns:xlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          viewBox="0 0 488.6 168.3"
                          // style="enable-background: new 0 0 488.6 168.3"
                          // xml:space="preserve"
                        >
                          <path
                            className="st0"
                            d="M2.8,59.3l2-19.8l22.8-18.3c0,0,8-5,12.3,0h12.8l10-7.7h20.3L97.5,25c0,0,3-4.8,11,1c0,0,4.5,1,5-0.5
	c0,0,2-7,13.5-0.3L147.5,7c0,0,4.3-7.8,11.5,0l43.3-1c0,0,7.5-7.3,10-0.8l16.8,14l30.5-1.3c0,0,5.8-4,12,5.5c0,0,24.5,0.8,28.5,7.4
	V34c0,0,14.5-5.8,17.5,8.3v4.3c0,0,13-7,10,6.8l2.8,3.8l1.8-3.8l12.3,0.3c0,0,9.8-4.8,14.8,0l43.8-3.3l22.5,15l3,2l50,6.5
	c0,0,7.8-1,7.5,7l0,85"
                          />
                        </svg>
                      </div>

                      <img className="img-hover" src={agendaHover} />
                    </figure>
                    <div className="text-box">
                      <img
                        data-aos="fade-in"
                        data-aos-delay="1000"
                        className="img-normal"
                        src={agendaText}
                      />
                      <img className="img-hover" src={agendaTextHover} />
                    </div>
                  </>
                </Link>
              </div>
            </div>

            <div className="layer-box layer-4" data-depth="0.1">
              <img className="city-image-4" src={cityline4} />
              <div className="boat-box">
                <Link to="/highlight">
                  <>
                    <figure>
                      <img
                        className="img-normal"
                        data-aos="fade-in"
                        data-aos-delay="1500"
                        data-aos-offset="-1000"
                        src={ImageFour}
                      />
                      <div className="image-outline">
                        <svg
                          version="1.1"
                          id="Layer_1"
                          xmlns="http://www.w3.org/2000/svg"
                          // xmlns:xlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          viewBox="0 0 704.8 306.7"
                          // style="enable-background: new 0 0 704.8 306.7"
                          // xml:space="preserve"
                        >
                          <path
                            className="st0"
                            d="M700.6,232.8c0,0,4.5,2.8-4.3,7.6l-0.6,14c0,0-1,5.4-2.1,5.3c0,0-3.5,16.6-14.3,1v-2.1h-13.8v8.8
		c0,0,0,4.9-7.5,3.9l-3.9-14.6c0,0,3.1,19.9-2.9,19.6c0,0-4.9-1.5-5.8-5.8c0,0,4.5,9.1-4.5,10.5c0,0-4.9-0.9-6.1-5.9l-14.6,2
		c0,0-6.4,0.6-6.1,5.9c0,0,1.1,17.1-7.3,21.1c0,0-73.4-6-113.5-11.4c0,0-12.4,2.5-145.4-33.7l-222.6-67.4l-50.4-17
		c0,0-17.5-3.6-37.7-18.1c0,0-21.1-11.9-33.4-27.4c0,0-6.1-11,6.5-17.1l5.6-4.8c0,0,3.5-1.4,1.9-4.9c0,0-3.8-7.1,3.9-7
		c0,0,2-6.5,10.6-6.8l3.3,0.6c0,0-10-22.4,40.2-24.6c0,0-11.3-2-2.8-7.4l21.5-7.4V6.7c0,0,4.6-9.4,8.6,0v42.8l25.8,0.3l3.4,1.3v-16
		c0,0,4.1-9.7,7.8,0l0.6,18.5c0,0,4.6,2.4,7.9,2.8c0,0,4.4,1.4,7.3-0.1c0,0,8.1,2.5,13,4.3l9.2-0.6c0,0-2.4-18.4,4.9-20.5V26.9
		c0,0,4.4-7.6,7.8,0v37.4c0,0,10.4,6.6,35.3,10.1c0,0-1.1-21.6,2-24.4V36c0,0,4.4-7.6,7.9,0v38.1c0,0,7.9,4.8,25.4,7.8V63.6
		c0,0-12.2-6.1,0.5-10.8l1-32.3c0,0,4.6-6.4,7.7,0.1v27.9c0,0,3.1,4.7,5.8-4V26.3c0,0,3.8-6.9,7.1,0v18.9c0,0,1.5,7,6.1,0.7v-20
		c0,0,3.2-6.9,7.1-0.8l1.4,5.9l1.3,1.1h3.7l0.5-4c0,0,3.9-6.3,7.6,0.3L312,36c0,0,4.1,5.4,5.8,0.5v-7.2l1.9-0.5V14.1
		c0,0,4.2-7.4,8.2,0v37.3c0,0,9.1,5.6,0,11.9v32.4l15.4,3.6V52.1c0,0-2.3-5.6,0-7.2V34.9c0,0,2.3-7.1,10.9-6.6c0,0,6,1.3,5.7,9.4
		l0,6.1c0,0,4.6,4.3-0.6,9.1l0.3,30.9l22.9-4.9l1.1-32.3c0,0-3.7-7.9,0.6-9.1c0,0-0.9-8.6,1.8-10.3c0,0,4.8-9.1,13.3,2.9v6.1
		c0,0,4.8,3.8,0,11.3l-0.2,28.1c0,0,53.4-10.2,73.7-10.2c0,0,88.5,18.8,125,24c0,0,5-3,4.9-12.9c0,0,1.1-35,7.4-11.3v25.8
		c0,0,27.5-0.8,13.1,21.5l-13.1,3l0.3,8.3c0,0,18.6-7.5,20.1,4.6c0,0,5.4,10.1-20.9,23.4c0,0,24.6-12.5,39,0v44.8l41.5,10.4
		c0,0,6.8-6.1,8.1,2.6v6.1C698.1,215.7,705.5,217.4,700.6,232.8z"
                          />
                        </svg>
                      </div>
                      <img className="img-hover img-main" src={boatHover} />
                    </figure>

                    <div className="text-box">
                      <img
                        data-aos="fade-in"
                        data-aos-delay="1000"
                        className="img-normal"
                        data-aos-offset="-1000"
                        src={highlightsText}
                      />
                      <img className="img-hover" src={highlightsTextHover} />
                    </div>
                  </>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Home;
